function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import moment from "moment";
import Moment from "react-moment";

class TimeAgo extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderUnixTimeAgo", () => {
      const unixTime = moment.unix(this.props.time);

      if (Math.abs(moment().diff(unixTime)) < 90000) {
        return 'Just Now';
      }

      return /*#__PURE__*/React.createElement(Moment, {
        fromNow: true,
        unix: true
      }, this.props.time);
    });

    _defineProperty(this, "renderTimeAgo", () => {
      if (Math.abs(moment().diff(this.props.time)) < 90000) {
        return 'Just Now';
      }

      return /*#__PURE__*/React.createElement(Moment, {
        fromNow: true
      }, this.props.time);
    });

    _defineProperty(this, "render", () => {
      return !!this.props.unix ? this.renderUnixTimeAgo() : this.renderTimeAgo();
    });
  }

}

export default TimeAgo;